var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13292_22634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.522 18.3301H3.77291C2.29627 18.3301 1.09375 17.1296 1.09375 15.6509V3.88181C1.09375 2.41517 2.28627 1.22266 3.7529 1.22266H9.35734V2.42318H3.7529C2.94855 2.42318 2.29427 3.07746 2.29427 3.88181V15.6529C2.29427 16.4673 2.95656 17.1316 3.77291 17.1316H15.524C16.3384 17.1316 17.0027 16.4693 17.0027 15.6529V10.0665H18.2032V15.6509C18.2012 17.1296 17.0007 18.3301 15.522 18.3301ZM18.1912 6.23483H16.9906V2.43318H13.189V1.23266H18.1912V6.23483Z",
    fill: "#026094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1763 1.39844L18.025 2.24721L10.089 10.1832L9.24023 9.33444L17.1763 1.39844Z",
    fill: "#026094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13292_22634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.648438 0.777344)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open_link.4e38b2a0f77ced05582d7310f816b890.svg";
export { ForwardRef as ReactComponent };